import { useField } from '@framework/ui/Organisms/FinalForm';

interface IOptions {
  allowNull?: boolean,
}

// allowNull defaults to false in react-final-form's useField, which silently coerces a `null`
// field value to '' - fine for display, wrong when the caller compares against raw data that uses null.
export const useFieldValue = <T>(name: string, { allowNull }: IOptions = {}) => {
  const field = useField<T>(name, { subscription: { value: true }, allowNull });
  return field.input.value;
};
